/*
 * サブシステム名：マスタ管理
 * 機能名：人員マスタ一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

const DdCheckbox = () => import('@/components/DdCheckbox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox.vue')
const DdDataTable = () => import('@/components/DdDataTable')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdSwitch = () => import('@/components/DdSwitch')
const DdTextBox = () => import('@/components/DdTextBox')

export default {
  name: 'MstJininList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      jininCd: '',
      jininNmSei: '',
      jininNmKanaSei: '',
      eigyoshoCd: '',
      jomuFlg: 'False'
    },
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDataTable,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader,
    DdSwitch,
    DdTextBox
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.seinengappiDisp = elem.seinengappi ? filter.dateFormatter(elem.seinengappi) : ''
        if (elem.jininNmSei) {
          elem.jininNmSeiMei = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        }
        if (elem.jininNmKanaSei) {
          elem.jininNmKanaSeiMei = elem.jininNmKanaSei + (elem.jininNmKanaMei ? ' ' + elem.jininNmKanaMei : '')
        }
        elem.eigyoshoNmDisp = elem.eigyoshoNm
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredTorihikisakiList () {
      // 取引先を出力
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return (elem.hacchusakiFlg === true || elem.torihikisakiBunruiKbn1 === '02') && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstJininList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '人員コード', value: 'jininCd' },
              { text: '人員氏名', value: 'jininNmSeiMei' },
              { text: '人員氏名カナ', value: 'jininNmKanaSeiMei' },
              { text: '所属営業所', value: 'eigyoshoNmDisp' },
              { text: '所属先', value: 'torihikisakiNm' },
              // { text: '乗務員フラグ', value: 'jomuFlgNm' },
              // { text: '乗務員種別', value: 'jomuSbtNm' },
              // { text: '人員略称', value: 'jininAbbr' },
              // { text: '性別', value: 'seibetsuKbnNm' },
              // { text: '血液型', value: 'ketsuekigataKbnNm' },
              // { text: '生年月日', value: 'seinengappiDisp', align: 'center' },
              // { text: '郵便番号', value: 'yubinNo' },
              // { text: '住所', value: 'jusho' },
              // { text: '電話番号', value: 'telNo' },
              // { text: '携帯番号', value: 'keitaiTelNo' },
              // { text: 'メールアドレス', value: 'mailAddress' }
              // { text: '職種', value: 'shokushuSbtNm' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              jininCd: '',
              jininNmSei: '',
              jininNmKanaSei: '',
              eigyoshoCd: '',
              jomuFlg: 'False'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstJininList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          var jomuFlgBool = c.jomuFlg === 'true'
          self.conditions.jomuFlg = jomuFlgBool
          console.log('★★★', self.conditions)
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstJininList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstJininList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstJininList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstJininList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCTgmstd0070/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              return {
              }
            })
        },
        getSavedInputMethod: function () {
          return {
            jomuFlg: self.conditions.jomuFlg
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              jininCd: '',
              jininNmSei: '',
              jininNmKanaSei: '',
              eigyoshoCd: '',
              jomuFlg: 'False'
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCTgmstd0070/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '人員マスタ一覧_' + ts + '.csv'
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
